module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Grand Prime White.65dae2e1.png";